var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chartShow)?_c('div',[_c('PieChart',{staticClass:"max-width-450",attrs:{"chart-data":_vm.chartPlayersData}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }